import React, {
  memo, useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Coupon from '../../../common/Coupon';
import ActiveAdvantageCrossSell from '../../../common/Offers/components/ActiveAdvantageCrossSell';

const CouponAndAaCross = ({
  trackingCallback,
}) => {
  const {
    entities: {
      AACrossToken,
    },
    isMatchedAACrossOffer,
  } = useSelector(state => state.offersData);

  const {
    entities: {
      orderInfo: {
        couponEnabled,
      },
    },
  } = useSelector(state => state.mainStateData);

  const singleColumn = useMemo(() => {
    return Boolean(isMatchedAACrossOffer) !== Boolean(couponEnabled);
  }, [ isMatchedAACrossOffer, couponEnabled ]);

  const classes = useMemo(() => {
    return classNames('coupon_and_aacross',
      {
        'offer-single-column': singleColumn,
        'cui-mg-t-20': couponEnabled || isMatchedAACrossOffer,
      },
    );
  }, [ singleColumn, couponEnabled, isMatchedAACrossOffer ]);

  if (!couponEnabled && !AACrossToken) {
    return null;
  }

  return (
    <div className={classes}>
      {couponEnabled && <div className="checkout_coupon-container">
        <Coupon trackingCallback={trackingCallback} />
      </div>}
      {AACrossToken && <div className={isMatchedAACrossOffer ? 'checkout_aacross-container' : 'empty-node'}>
        <ActiveAdvantageCrossSell/>
      </div>}
    </div>);
};

export default memo(CouponAndAaCross);
